
import { useParams } from "react-router-dom";
import PopularJobRolesList from "./PopularJobRolesList";

export function JobByRolesPage() {
    const { uuid } = useParams();
    return (
      <div>
        <PopularJobRolesList uuid={uuid} />
      </div>
    );
  }